import styled from 'styled-components'
import RoundedButton from 'components/RoundedButton'
import TextInput from 'components/TextInput'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const InputRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
  width: 100%;
`

export const InputContainer = styled(TextInput)`
  width: 100%;
  height: 20px;
  font-size: 12px;
  margin-bottom: 10px;
`

export const Label = styled.div`
  font-family: 'EBGaramond', sans-serif;
  font-size: 20px;
  margin-right: 20px;
  min-width: 50px;
  width: 100px;
`

export const ButtonsContainer = styled.div`
  margin-top: 40px;
`

export const ConfirmButton = styled(RoundedButton)`
  width: 100%;
`
